export default (value: string) => {
    if (value.indexOf(' ') >= 0) {
      return value;
    }

    const toUppercase = (str: string): string => str.toUpperCase();
    return value.replace(/[A-Z]/g, ' $&').replace(/^./, toUppercase);
};
